import React, { useState } from "react";
import NavLinks from "./NavLinks";
import "../Navbar/styles/TopBar.scss";

function MobileNavigation() {
  const [open, setOpen] = useState(false);
  const toggleHamburger = () => {
    setOpen((prev) => !prev);
  };

  const closeMobileMenu = () => setOpen(false);

  return (
    <nav className="mobile-navigation">
      <div className="hamburger-menu-wrapper">
        <div className="row cf">
          <div
            id="hamburger-6"
            className={`hamburger ${open ? "is-active" : ""}`}
            onClick={toggleHamburger}
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      </div>

      {open && <NavLinks isMobile={true} closeMobileMenu={closeMobileMenu} />}
    </nav>
  );
}

export default MobileNavigation;
